import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
    blogSlider();
});

function blogSlider() {
    new Swiper('.blog .swiper-container', {
        modules: [Pagination], loop: true, slidesPerView: 1.2, spaceBetween: 12, centeredSlides: true, pagination: {
            el: ".swiper-pagination", clickable: true,
        }, breakpoints: {
            450: {
                slidesPerView: 1.4, spaceBetween: 16,
            }, 600: {
                slidesPerView: 1.8, spaceBetween: 16,
            }, 700: {
                slidesPerView: 2.2, spaceBetween: 16,
            }, 900: {
                slidesPerView: 2.6, spaceBetween: 16,
            }, 1100: {
                slidesPerView: 3.2, spaceBetween: 16,
            }, 1300: {
                slidesPerView: 3.8, spaceBetween: 16,
            }, 1600: {
                slidesPerView: 4.4, spaceBetween: 16,
            }, 1900: {
                slidesPerView: 5, spaceBetween: 16,
            }, 2200: {
                slidesPerView: 5.6, spaceBetween: 16,
            }, 2500: {
                slidesPerView: 6.2, spaceBetween: 16,
            }
        }
    });
}